export class PutDashboardRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "isShared",
            "baseName": "isShared",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sessionId",
            "baseName": "sessionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "spec",
            "baseName": "spec",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PutDashboardRequest.attributeTypeMap;
    }
    constructor() {
    }
}
